<div class="card-header bg-light">
    <h4 class="card-title mb-0">
        <i class="far fa-file"></i> Cancelar Folha Teste
    </h4>
</div>

<form class="needs-validation" novalidate id="myForm" #f="ngForm">
    <div class="card-body">
        <div class="p-2 wrapper">
            <div class="row mb-2">
                <div class="col-md-2 mb-2">
                    <label class="form-label">Nº Folha Teste</label>
                    <input type="text" class="form-control form-control-sm" disabled placeholder="-"
                        [ngModel]="model?.numeroFolha" [ngModelOptions]="{ standalone: true }" />
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-12 mt-2">
                    <label class="form-label">Justificativa</label>
                    <textarea class="form-control" rows="3" maxlength="500" name="justificativaCanc"
                        [(ngModel)]="model.justificativaCanc"
                        placeholder="Digite uma Justificativa para o cancelamento"></textarea>
                </div>
            </div>
        </div>
    </div>

    <div class="card-footer">
        <div class="d-flex w-100 justify-content-between align-items-center">
            <div class="list1">
                <button class="btn btn-primary btn-sm mr-1" (click)="cancelar()">
                    <i class="far fa-save"></i> Salvar
                </button>
                <button type="button" class="btn btn-default btn-sm mr-1" (click)="fechar()">
                    <i class="fas fa-times"></i> Cancelar
                </button>
            </div>
        </div>
    </div>
</form>